import { UseMutationOptions, useMutation } from 'react-query';

import { ResyncUserStatus } from '@pimm/services/lib/sms-workforce/services';
import type { TeamMember } from '../types';

// POST /api/Workforce/TeamMembers/ResyncUserStatus — 409s when the employee has
// no linked user. Same whole-record-replace response contract as
// UpdateTeamMember: the resolved value is the complete refreshed record.
export type ResyncUserStatusVars = { employeeId: string };

export const useResyncUserStatus = (options?: UseMutationOptions<TeamMember, unknown, ResyncUserStatusVars>) =>
  useMutation({
    mutationFn: async (vars: ResyncUserStatusVars) => (await ResyncUserStatus(vars)) as TeamMember,
    ...options,
  });
